import React, { useState, useEffect, useCallback } from 'react';
import { CheckCircle } from 'lucide-react';

const ProceduralObservationGame = ({ config, onEnd }) => {
    const [gridItems, setGridItems] = useState([]);
    const [targetItem, setTargetItem] = useState(null);
    const [found, setFound] = useState(false);
    const [level, setLevel] = useState(1);
    const [mistakes, setMistakes] = useState(0);

    // Utilisation de useCallback pour stabiliser la fonction
    const generateLevel = useCallback(() => {
        setFound(false);
        const mode = config.mode || 'find_item';
        let target, distractors;

        if (mode === 'find_intruder') {
            if (!config.pairs || config.pairs.length === 0) return;
            const pair = config.pairs[Math.floor(Math.random() * config.pairs.length)];
            target = pair.target;
            distractors = [pair.distractor];
        } else {
            if (!config.items || config.items.length === 0) return;
            const pool = [...config.items];
            const targetIndex = Math.floor(Math.random() * pool.length);
            target = pool[targetIndex];
            distractors = pool.filter(i => i !== target);
        }

        setTargetItem(target);

        // Difficulté progressive
        const gridSize = Math.min(12 + (level * 4), 40);
        let items = [{ id: 'target', content: target, isTarget: true }];

        for (let i = 0; i < gridSize - 1; i++) {
            const distractor = distractors[Math.floor(Math.random() * distractors.length)];
            items.push({ id: `d-${i}-${level}`, content: distractor, isTarget: false });
        }

        // Mélange
        items.sort(() => Math.random() - 0.5);
        setGridItems(items);
    }, [config, level]); // La fonction ne change que si config ou level change

    // useEffect ne dépend maintenant que de generateLevel
    useEffect(() => {
        generateLevel();
    }, [generateLevel]);

    const handleItemClick = (item) => {
        if (found) return;
        if (item.isTarget) {
            setFound(true);
            setTimeout(() => {
                if (level < 5) {
                    setLevel(prev => prev + 1);
                } else {
                    onEnd(10 - mistakes);
                }
            }, 1500);
        } else {
            setMistakes(m => m + 1);
        }
    };

    if (level > 5) return null;

    return (
        <div className="observation-container">
            <div className="observation-header">
                <h2 className="observation-title">
                    {config.mode === 'find_intruder' ? "Trouvez l'intrus !" : "Cherchez l'objet indiqué"}
                </h2>
                {config.mode !== 'find_intruder' && (
                    <div className="observation-target-display">
                        {targetItem}
                    </div>
                )}
                <p className="observation-level">Niveau {level} / 5</p>
            </div>

            <div className="observation-grid">
                {gridItems.map((item) => (
                    <button
                        key={item.id}
                        onClick={() => handleItemClick(item)}
                        className={`grid-item ${item.isTarget && found ? 'target-found' : ''} ${found && !item.isTarget ? 'dimmed' : ''}`}
                    >
                        {item.content}
                    </button>
                ))}
            </div>

            {found && (
                <div className="observation-success">
                    <CheckCircle className="icon" /> Bravo !
                </div>
            )}
        </div>
    );
};

export default ProceduralObservationGame;